import React from 'react';
import { IconProps } from '@/icons/icon';

const Fondo2: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 402 874" /* Mantiene la proporción original */
      preserveAspectRatio="xMidYMid slice" /* Ajusta la escala correctamente */
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className} // Permite aplicar estilos desde CSS
    >
      <g clipPath="url(#clip0_59_44)">
        <rect width="100%" height="100%" fill="white" />
        <g clipPath="url(#clip1_59_44)">
          <mask id="mask0_59_44" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="-58" y="-537" width="483" height="1503">
            <path d="M425 -537H-58V966H425V-537Z" fill="white" />
          </mask>
          <g mask="url(#mask0_59_44)">
            <path
              d="M-125.558 480.515C-125.558 480.515 3.15611 555.463 141.472 468.423C279.788 381.391 316.291 318.535 435.396 393.475L449.52 1089.36H-126.802L-125.558 480.507V480.515Z"
              fill="var(--primary-color)"
            />
          </g>
        </g>
        <g clipPath="url(#clip2_59_44)">
          <mask id="mask1_59_44" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="-58" y="265" width="483" height="280">
            <path
              d="M-58 506.907C-54.8502 506.603 -51.6622 506.163 -48.4361 505.611C-51.7511 502.57 -54.9391 499.433 -58 496.232V506.915V506.907ZM150.525 408.528C124.869 418.827 99.9814 431.966 76.2178 447.907C46.5292 467.816 -4.09061 497.945 -48.4234 505.603C8.62944 557.865 103.353 580.616 243.896 427.309C263.132 406.327 281.021 387.61 297.634 370.973C259.176 373.014 211.033 384.241 150.531 408.528M297.628 370.973C365.134 367.388 402.786 392.107 425 424.164V265C394.225 282.989 352.954 315.542 297.628 370.973Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_59_44)">
            <path d="M420.548 265.216H-62.4453V580.84H420.548V265.216Z" fill="var(--light-primary-color)" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_59_44">
          <rect width="100%" height="100%" fill="white" />
        </clipPath>
        <clipPath id="clip1_59_44">
          <rect width="483" height="1503" fill="white" transform="translate(-58 -537)" />
        </clipPath>
        <clipPath id="clip2_59_44">
          <rect width="483" height="280" fill="white" transform="translate(-58 265)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Fondo2;
